import { render, staticRenderFns } from "./g-map-matching-sites.vue?vue&type=template&id=8fa3947e&scoped=true"
import script from "./g-map-matching-sites.vue?vue&type=script&lang=js"
export * from "./g-map-matching-sites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa3947e",
  null
  
)

export default component.exports